var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{ref:"orgCascader",style:(_vm.customStyle),attrs:{"placeholder":"请选择机构","props":_vm.props,"clearable":"","show-all-levels":false},on:{"change":_vm.changeListen},model:{value:(_vm.checkData),callback:function ($$v) {_vm.checkData=$$v},expression:"checkData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }